import type { ISxProps } from '@/CommonComponents/types'
import { LinearProgress as MUILinearProgress } from '@mui/material'
import { Typography, Box } from '@/CommonComponents'
import { COLORS } from '@/lib/constants/colors'
const { PROGRESS_BAR } = COLORS
interface IProgressBarProps {
  sx?: ISxProps
  progress?: number
  labeled?: boolean
  colored?: boolean
}
const getColor = (progress: number, colored?: boolean) => {
  if (!colored) return { backgroundColor: PROGRESS_BAR.BACKGROUND, color: PROGRESS_BAR.COLOR }
  let color = PROGRESS_BAR.ERROR
  if (progress >= 75) color = PROGRESS_BAR.COLOR
  else if (progress >= 50) color = PROGRESS_BAR.WARNING
  return { backgroundColor: PROGRESS_BAR.BACKGROUND, color }
}
export default function ProgressBar({ sx, progress, colored }: IProgressBarProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <MUILinearProgress
          variant="determinate"
          color="inherit"
          sx={getColor(progress ?? 0, colored)}
          value={progress}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${progress}%`}
        </Typography>
      </Box>
    </Box>
  )
}
